(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
      // Scroll To top
      document.addEventListener('DOMContentLoaded', function() {
      var scrollButton = document.getElementById('scroll');
      // Hide the scroll button initially
      scrollButton.classList.add('scrollhide');
      window.addEventListener('scroll', function() {
          if (window.scrollY === 0) {
              scrollButton.classList.add('scrollhide');
          } else {
              scrollButton.classList.remove('scrollhide');
          }
      });
      scrollButton.addEventListener('click', function(e) {
          e.preventDefault();
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
              class ProductModal extends ModalDialog {
                  constructor() {
                  super();
                  }

                  hide() {
                  super.hide();
                  }

                  show(opener) {
                  super.show(opener);
                  this.showActiveMedia();
                  }

                  showActiveMedia() {
                  this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                      element.classList.remove('active');
                      }
                  )
                  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                  const activeMediaTemplate = activeMedia.querySelector('template');
                  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                  activeMedia.classList.add('active');
                  activeMedia.scrollIntoView();

                  const container = this.querySelector('[role="document"]');
                  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                  if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                      activeMedia.loadContent();
                  }
              }

              customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
